import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalService {

  key = "123";

 private keysData = new BehaviorSubject<any>(null);
 public currentKeysData$ = this.keysData.asObservable();



  constructor() { }

  getAllKeys() {
    let model = Object.create({});
    Object.keys(localStorage).forEach(key => {
      if(key.includes("interceptor")) {
        const originalValue = this.getData(key);
        const originalKey = key.replace(/interceptor./g,'');
        model[originalKey] = originalValue;
      }
    });
    return model;
  }

  setAllKeys(model: any) {
    Object.keys(model).forEach(key => {
      this.saveData("interceptor."+key, model[key].toString());
    });
    this.keysData.next(model);
  }


  public saveData(key: string, value: string) {
    localStorage.setItem(key, this.encrypt(value));
    //this.keysData.next(key);
  }

  public getData(key: string) {
    let data = localStorage.getItem(key) || "";
    return this.decrypt(data);
  }
  public removeData(key: string) {
    localStorage.removeItem(key);
  }

  public clearData() {
    localStorage.clear();
  }

  private encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(txt, this.key).toString();
  }

  private decrypt(txtToDecrypt: string) {
    return CryptoJS.AES.decrypt(txtToDecrypt, this.key).toString(CryptoJS.enc.Utf8);
  }
}
